export default {
  menu: {
    sports: "Sukan",
    referAndEarn: "Rujuk dan Perolehi",
    referDesc: "sehingga 60% komisen",
    copyLink: "Salin Pautan",
    hot: "Popular",
    favorites: "Kegemaran",
    recent: "Terkini",
    vipClub: "Kelab VIP",
    bonus: "Bonus",
    bonusGames: "Permainan Bonus",
    affiliate: "Gabungan",
    promotion: "Promosi",
    rewards: "Ganjaran",
    help: "Bantuan",
    feedback: "Maklum Balas",
    downloadApp: "Muat Turun Aplikasi",
    claimBonus: "Tuntut Bonus",
    redeemCode: 'Tebus Kod',
    redeemDesc: 'Tuntut Ganjaran Percuma Anda',
    liveSupport: "Sokongan Langsung",
    language: "Bahasa",
	search: "search"
  }
}
